import { NotifyHelper } from "../../../helpers/toast";
import { objNgayNghiDefine } from "../../action-types/danh-muc/INgayNghiActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const ngayNghiActions = {
    ...generateActions(objNgayNghiDefine, "NGAY_NGHI"),
    ...generateActionForKey(objNgayNghiDefine, "NGAY_NGHI",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objNgayNghiDefine, "NGAY_NGHI",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objNgayNghiDefine, "NGAY_NGHI",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objNgayNghiDefine, "NGAY_NGHI",
        "SAVE_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objNgayNghiDefine, "NGAY_NGHI",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objNgayNghiDefine, "NGAY_NGHI",
        "DELETE_SUCCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objNgayNghiDefine, "NGAY_NGHI",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
